// Действия над оформленным заказом: повтор, отмена, смена способа оплаты,
// онлайн-оплата. Один и тот же набор нужен и карточке в списке (OrderCard),
// и странице заказа (OrderDetails) — держим в одном месте, чтобы правила
// (подтверждения, порядок навигации, кто перезагружает список) не разъезжались.
//
// Компонент-хозяин должен иметь state { busy: {}, error: null } и стора в
// props: orderStore, cart (cartStore).
import { runBusy, isBusy } from './busy';

export function repeatOrder(cmp, id) {
  if (isBusy(cmp, 'repeat:' + id) || isBusy(cmp, 'cancel:' + id)) return;
  // Действие разрушительное: v3/crt/repeat сначала делает
  // clean_cart_and_order и только потом наполняет корзину из заказа.
  // В приложении эта же кнопка закрыта ConfirmModal (repeatOrderConfirm).
  if (!window.confirm('Повторить заказ? Текущая корзина будет заменена.')) return;
  cmp.setState({ error: null });
  runBusy(cmp, 'repeat:' + id, async () => {
    await cmp.props.cart.repeatOrder(id);
    window.location.href = '/cart'; // навигация — последним шагом
  }).catch((e) => cmp.setState({ error: e.message || 'Не удалось повторить заказ' }));
}

export function cancelOrder(cmp, id, onDone) {
  if (isBusy(cmp, 'cancel:' + id) || isBusy(cmp, 'repeat:' + id)) return;
  if (!window.confirm('Отменить заказ?')) return;
  cmp.setState({ error: null });
  runBusy(cmp, 'cancel:' + id, async () => {
    await cmp.props.orderStore.cancelOrder(id);
  })
    // Продолжение — вне runBusy: после перезагрузки списка карточка может
    // переехать в другую секцию и размонтироваться, а setState(busy=false)
    // внутри runBusy отработал бы уже по мёртвому инстансу.
    .then(() => (onDone ? onDone() : null))
    .catch((e) => cmp.setState({ error: e.message || 'Не удалось отменить заказ' }));
}

export function changePayType(cmp, id, payTypeId) {
  if (!payTypeId || isBusy(cmp, 'pay:' + id)) return;
  cmp.setState({ error: null });
  // Список обновляет сам стор — заказ остаётся на месте, ничего не размонтируется.
  runBusy(cmp, 'pay:' + id, async () => {
    await cmp.props.orderStore.changePayType(id, payTypeId);
  }).catch((err) => cmp.setState({ error: err.message || 'Не удалось изменить способ оплаты' }));
}

// Платим способом, который стоит у заказа — выбирать нечего: кнопка есть
// только под онлайн-способ (см. Orders::ClientOrderPayPolicy).
export function payOrderOnline(cmp, id) {
  if (isBusy(cmp, 'online:' + id)) return;
  cmp.setState({ error: null });
  runBusy(cmp, 'online:' + id, async () => {
    const res = await cmp.props.orderStore.payExistingOrder(id);
    if (res && res.redirect) {
      window.location.href = res.redirect; // навигация — последним шагом
    }
    // Без редиректа список перечитывает сам стор (payExistingOrder).
  }).catch((err) => cmp.setState({
    error: (err.body && err.body.error) || err.message || 'Не удалось оплатить заказ',
  }));
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/orderActions.js